import * as React from 'react'

function SvgComponent({ fill = '#ff5200' }) {
	return (
		<svg
			width={30}
			height={30}
			viewBox='0 0 30 30'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M19.688 15c-1.205 0-2.37-.538-3.282-1.514-.886-.952-1.428-2.222-1.523-3.574-.102-1.443.338-2.77 1.239-3.736.9-.967 2.16-1.489 3.566-1.489 1.396 0 2.659.531 3.556 1.496.907.974 1.348 2.298 1.246 3.728-.098 1.354-.639 2.623-1.523 3.574-.91.977-2.074 1.515-3.28 1.515zm7.724 10.313H11.964a1.624 1.624 0 01-1.29-.626 1.771 1.771 0 01-.307-1.51c.493-1.982 1.715-3.625 3.534-4.752 1.614-1 3.669-1.55 5.787-1.55 2.159 0 4.16.527 5.783 1.526 1.823 1.121 3.047 2.774 3.538 4.779a1.773 1.773 0 01-.311 1.51 1.622 1.622 0 01-1.286.622zM8.613 15.233c-2.062 0-3.874-1.917-4.043-4.273-.083-1.207.293-2.323 1.055-3.142.754-.81 1.816-1.256 2.988-1.256s2.227.448 2.985 1.263c.767.825 1.142 1.94 1.054 3.136-.168 2.356-1.98 4.272-4.039 4.272zm3.848 1.843c-1.031-.504-2.369-.756-3.847-.756-1.726 0-3.403.45-4.721 1.267-1.495.928-2.5 2.278-2.906 3.909a1.605 1.605 0 00.28 1.369 1.484 1.484 0 001.178.572h6.503a.469.469 0 00.462-.386c.006-.036.014-.073.024-.11.497-1.995 1.66-3.682 3.381-4.91a.47.47 0 00-.037-.785 4.745 4.745 0 00-.317-.17z'
				fill={fill}
			/>
		</svg>
	)
}

export default SvgComponent
